<div class="tests-page">
    <h1 class="tests-title">Pages de tests</h1>
    <div class="tests-grid">
        <a class="test-card" routerLink="/tests/debug-referents-parc">
            <span class="material-symbols-outlined">manage_accounts</span>
            <span class="test-card-name">Debug référents Parc</span>
        </a>
        <a class="test-card" routerLink="/tests/debug-chiffres-utiles">
            <span class="material-symbols-outlined">calculate</span>
            <span class="test-card-name">Debug chiffres utiles Parc</span>
        </a>
    </div>
</div>
